/*
* Copyright (c) 2023 Eugenio Espinoza
*
* Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"),
* to use the Software solely for personal, non-commercial purposes. Any commercial use, distribution, sublicense, sale, or modification of the Software
* is strictly prohibited without the explicit written permission of the copyright holder.
*
* For licensing inquiries, please contact Eugenio Espinoza at mail.eugenioespinoza.com .
*
* THE SOFTWARE IS PROVIDED "AS IS," WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
* FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
* WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/

import React, { useEffect } from 'react';
import Navbar from './components/Navbar/Navbar';
import './App.css';
import {BrowserRouter as Router, Switch, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Links from './pages/Links'
import Portal from './pages/Portal';
import ErrorBoundary from './components/ErrorBoundary';
import { installDevLogging } from './portal/devlog';




function App() {

  // Forwards uncaught browser errors to the PHP log so the webmaster portal
  // can show what visitors are actually hitting.
  useEffect(() => {
    installDevLogging();
  }, []);

  return (
    <>
    <ErrorBoundary>
    <Router>
    <SiteNavbar />
    <Switch>
      <Route path='/portal' component={Portal} />
      <Route path='/' exact component={Home} />
      <Route path='/links' exact component={Links}/>

    </Switch>
    </Router>
    </ErrorBoundary>
    </>
  );
}

/** The marketing navbar has no place inside the signed-in portal. */
function SiteNavbar() {
  const location = useLocation();
  if (location.pathname.indexOf('/portal') === 0) {
    return null;
  }
  return <Navbar />;
}

export default App;
